import './app.css';
import React, { Component } from 'react';
import { Router, Route, Redirect, Prompt } from 'react-router-dom';
import history from '../../utils/history';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Focus from './../../components/Focus';
import Resume from './../../components/Resume';
import Header, { getLinksFromNavConfiguration } from '../../components/Header/index';
import Spinner from './../../components/Spinner';
import WaterMark from './../../components/Watermark';
import NewNewVCard from '../../components/Ficha/VCard';
import VCardTv from '../../components/Ficha/Tv';
import Talent from '../../components/Ficha/Talent';
import Playlist from '../../components/PlaylistDetail/NewPlaylistDetail';
import Album from '../../components/AlbumDetail/NewAlbumDetail';
import Artist from '../../containers/ArtistDetail/NewArtistDetail';
import GenreRadioList from '../../components/GenreRadioList';
import ArtistRadioList from '../../components/ArtistRadioList';
import json from '../../utils/data/channels';
import Marquee from './../../components/Marquee';
import MyContent from '../MyContent';
import UserSettings from './../User-Settings';
import About from './../About';
import ChooseSearcher from './../Search/ChooseSearcher';
import DeviceNetworkStatus from '../../utils/DeviceNetworkStatus';
import EpgVersionStatus from '../../utils/EpgVersionStatus';
import FullVideo from '../../components/Video/FullVideo';
import EndPlayer from '../../components/Video/EndPlayer';
import PipVideo from '../../components/Video/PipVideo';
import Notification from './../../components/Notification';
import ModalConductor from '../Modal';
import {
  showModal,
  MODAL_UPDATE_EMAIL,
  MODAL_EXIT,
  MODAL_PPE,
  MODAL_PIN,
  MODAL_LANGUAGES,
  HIDE_MODAL,
  MODAL_GENERIC,
  MODAL_INACTIVITY,
  AAF_MODAL_SUSPENDED_ACCOUNT
} from '../../actions/modal';
import Payment from './../../components/Payment/Index';
import PlanSelectorNew from '../../payments/PlanSelector'
//TODO toggle for metadata?
import TransactionDetailContainer from '../../payments/Checkout';
import DetailSelector  from '../../payments/DetailSelector';
import { showNotification, showEventReminderNotification, hideNotification } from '../../actions/notification';
import { playFullMedia, playPipMedia } from '../../actions/playmedia';
import {
  fetchIsLoggedIn,
  fetchSmartCardLogin,
  fetchFavoriteVOD,
  fetchFavoriteChannels,
  fetchAuthDevice,
  fetchPushSession,
  setAacceptedTerms,
  fetchAuthDeviceCMR,
  fetchLoginByToken,
  continueProcessLoginByToken
} from '../../reducers/user';
import { fetchLinealChannels } from '../../actions/payway';
import Metadata from '../../requests/apa/Metadata';
import MyContentTask from '../../requests/tasks/cms/MyContentTask';
import MyContentsettings from '../MyContent/settings';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import NodeContent from '../../containers/NodeContent';
import Debugger from './../../components/Debugger';
import settings, {IPTV, OTT} from './../../devices/all/settings';

import CCOM from '../../devices/nagra/CCOM';
import SpecialContainer from '../Special';
import ReminderNotifications from '../../utils/RemindersNotifications/ReminderNotifications';
import UtilsIsLoggedIn from '../../utils/user/isLoggedIn';
import utilsIsSticky from '../../utils/user/IsSticky';
import UtilsEPG from '../../utils/epg/clearCache';
import Device from '../../devices/device';
import UtilsCMRExperience from '../../utils/userCMR/isCMRExperience';

import RequestManager from '../../requests/RequestManager';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import FrontPanel from './../../devices/nagra/FrontPanel';
import ControlVolume from './../../devices/nagra/Volume';
import VolumeIndicator from './../../components/VolumeIndicator';
import { replaceFullSourceMedia } from '../../actions/playmedia';
import SocialContainer from '../Social/SocialContainer';
import Profile from '../Profile';
import PTV from '../../authentication/Ptv';
import { setMetricsEvent } from '../../actions/metrics';
import Npvr, { RecordingSingleton } from '../../utils/Npvr';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import Utils , { getAuthdeviceConfig, getOnboardingConfig, getSuspendedAccountLabels, getEnableCMRExperience, isLandingTelmexEnabled, getImageFromAsset, preloadImage, promiseImageLoad, getDynamicImage, isLoadingScreenEnabled} from '../../utils/Utils';
import UtilsProfile from '../../utils/Profile';
import TvChannelUtil from '../../utils/TvChannelUtil';
import LayersControl from '../../utils/LayersControl';
import PPE from './../../devices/nagra/PPE';
import store from './../../store';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';

import {
  AAFPLAYER_PLAY,
  AAF_CONTENT_IS_STARTOVER,
  AAF_CONTENT_IS_TIMESHIFT,
  AAF_CONTENT_IS_VOD,
  AAF_CONTENT_IS_NPVR,
  AAF_CONTENT_IS_AUDIO,
  AAF_CONTENT_IS_RADIO,
  AAFPLAYER_STOP,
  AAF_CONTENT_IS_TV,
} from '../../AAFPlayer/constants';
import ActivesSingleton from '../../components/Header/ActivesSingleton';
import {setResumeData} from '../../actions/resume';
import {setNodes} from '../../actions/navbar';
import pkg from '../../../package.json';
import TimeOutAAF from '../../utils/TimeOutAAF';
import AAF from '../../AAF/AAF';
import EpgFeederManager from '../../AAFPersistenceManager/feeders/EpgFeederManager';
import { RibbonsObserver, LiveObserver, HidePlayerControlsObserver, ClearTextSearch } from '../../components/PersistentMiniEpg/MiniObserver';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import { isLoggedIn } from '../../requests/loader';
import { receiveIsLoggedIn } from '../../reducers/user';
import LoadExperience from '../../AAF/LoaderExp/LoadExperience';
import FallbackHelper from '../../AAFPlayer/helpers/FallbackHelper';
import LandingResolver from '../../authentication/components/LandingResolver/index'
import Login from '../../authentication/Login';
import LoginCM from '../../authentication/LoginCM'
import Register from '../../authentication/Register';
import PasswordReminder from '../../authentication/PasswordReminder';
import AuthDevice from '../../authentication/AuthDevice';
import LoadRegisterIpTelmex from '../../authentication/components/LoadRegisterIPtelmex/container';
import LoadPtv from '../../AAF/LoaderExp/LoadPtv';
import {
  AUTOLOGIN_EVENT_LABEL,
  AUTOLOGIN_EVENT_ACTION,
  AUTOLOGIN_EVENT_CATEGORY,
  AUTOLOGIN_EVENT_SUCCESS_LABEL,
  AUTOLOGIN_EVENT_ERROR_LABEL_PREFIX
} from './constants';
import { createAsyncEvent } from '../../utils/analytics';
import NpvrUploader from '../../AAF/Npvr/NpvrUploader';
import { NpvrUtil } from '../../AAF/Npvr/NpvrUtil';
import LoadingIptvOttFlow from '../../AAF/LoaderExp/LoadingIptvOttFlow';
import { setLastTouchReminder } from '../../reducers/user';
import PaymentMethods from '../../payments/PaymentMethods';
import PaymentHubGate from '../../payments/HubGate';
import PaymentPromoGate from '../../payments/PromoGate';
import PaymentCard from '../../payments/ClaroPagosGate';
import HubFacturaFijaGate from '../../payments/HubFacturaFijaGate';
import HubFija from '../../payments/HubFija';
import PaymentGate from '../../payments/ClaroColombiaGate';
import HubBidirectional from '../../payments/HubBidirectional';
import HubBidirectionalCO from '../../payments/HubBidirectionalCO';
import LoadFav from '../../AAF/LoaderExp/LoadFav';
import { ThirdPartyEpgHelper, TPA_WAS_FIRED } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';
import { FROM_APP, Resilence } from '../../AAF/Resilence/main';
import Match from '../../mundial/Tabs/Match';
import Calendar from '../../mundial/Tabs/Calendar';
import Groups from '../../mundial/Home/Groups';
import Teams from '../../mundial/Home/Teams';
import {handleOnKeyPressModalInactivity} from 'src/components/Modal/functions/ModalInactivity/index';
import PlayerControlsLogic from 'src/playerDomain/components/PlayerControlsLogic'
import LandingPageSTB from '../../components/LandingPage/LandingPageSTB';
import UtilsSearch from '../Search/UtilsSearch';
import NewRelic from '../../utils/trackers/NewRelic';
import LandingTVEverywhere from '../../components/LandingTVEverywhere';
import TVEverywhereCheckTask from '../../requests/tasks/user/TVEverywhereCheckTask';
import { LOGIN_RESPONSE_TYPE } from '../../AAF/Auth/authConstants';
import { AdsUtils } from '../../AAF/Ads/Utils';
import Constants from '../../AAF/Ads/Constans';
import { setContentDataPublicity } from '../../actions/ads';
import {CLASSES_FOCUSED} from "../../components/Focus/constants";
import {reviewActiveElement} from "../../components/Focus/utils";
import {removeDynamicFocus} from "../../../src/components/Focus/utils";
import LoadingScreen from '../../components/LoadingScreen';
import { getTextNodeClaroSportsGuia, getNodeFrom } from './utils' ;
import { ca } from 'date-fns/locale';

import Config from '../config/Config';
import ConfigDetails from '../ConfigDetails/ConfigDetails';

const CLARO_MUSICA_NODE = 'claromusica';

/* TODO nagratv hardcodes */
class App extends Component {
  constructor(props) {
    super(props);
    this.history = history;
    this.CCOM = CCOM;
    this.turn = true;
    this.showAlert = false;
    this.state = {
      nodes: [],
      isFetching: false,
      orden: true,
      src1: '',
      src2: '',
      vol: ControlVolume.get(),
      myChannels: [],
      gpID: '',
    };
    this.esteCanal = 0;
    this.json = [];
    this.continueFlowIPTV = true;
    Object.keys(json).map((key, idx) => {
      this.json.push(key);
    });

    this.device = Device.getDevice().getPlatform();
    this.keys = Device.getDevice().getKeys();
    this.lastKey = null;
    this.delayKeyTime = 90; //MS
    this.delayTimerId = null;
    this.isKeysBloqued = false;
    this.channelJSON = [];
    this.stopRender =
      window.navigator.userAgent.toLowerCase().indexOf('stb') !== -1 ? true : false;
    this.timerNotificationRecordings = 300000; // 5 min

    this.checkIfShowAlert = this.checkIfShowAlert.bind(this);
    this.isLoggedInCallback = this.isLoggedInCallback.bind(this);
    this.showNoticePrivacy = this.showPrivacyPolicyModal.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.checkAppkeyForce = this.checkAppkeyForce.bind(this);
    this.checkStatusPin = this.checkStatusPin.bind(this);
    this.getConfigRemoteControl = this.getConfigRemoteControl.bind(this);
    this.changePath = this.changePath.bind(this);
    this.setAafLiveHistory = this.setAafLiveHistory.bind(this);
    this.handlePopState = this.handlePopState.bind(this);
    this.refresh = this.refresh.bind(this);
    this.setStopRender = this.setStopRender.bind(this);
    this.isNodeTV = this.isNodeTV.bind(this);
    this.showSuspendedAccountModal = this.showSuspendedAccountModal.bind(this);

    FrontPanel.clearDisplay();

    this.playInit = this.playInit.bind(this);
    this.setMetricsEvent = this.setMetricsEvent.bind(this);
    this.updateFavoriteChannels = this.updateFavoriteChannels.bind(this);
    this.updateFavoriteVOD = this.updateFavoriteVOD.bind(this);
    this.myChannels = new MyContentTask(MyContentsettings.myChannels);
    this.swapPin = 0;

    this.history.listen((location, action) => {
      this.lastHistoryHash = {
        key: location.key,
        pathname: location.pathname,
        liveparams: null
      };
    });
    this.blockedChannels = [];

    // Para manejo de backs en player full live
    this.lastHistoryHash = {};
    this.aafLiveHistory = {};
    this.toggleFunctions = Utils.getToggleFunctionsFromMetadata();

    DeviceStorage.setItem('appVersion', pkg.version);
    const appVersionApi = DeviceStorage.getItem('appVersionApi');
    if (!appVersionApi) {
      DeviceStorage.setItem('appVersionApi', pkg.version);
    }
    this.updateApp = [];
    this.wasBackFromFull = false;
    this.callbackAfterLoginInProfile = this.callbackAfterLoginInProfile.bind(this);
    this.stickySuccess = this.stickySuccess.bind(this);
    this.chargeLiveComponents = this.chargeLiveComponents.bind(this);
    this.startEpgChecker = this.startEpgChecker.bind(this);
    this.EpgDataLoading = this.EpgDataLoading.bind(this);
    this.getReminders = this.getReminders.bind(this);
    this.getRecordings = this.getRecordings.bind(this);
    this.ifPromptTVNode = this.ifPromptTVNode.bind(this);
    this.getLinks = this.getLinks.bind(this);
    this.getNavData = this.getNavData.bind(this);
    this.showLandingTVEverywhere = this.showLandingTVEverywhere.bind(this);
    this.goToLandingTvEverywhere = false;
    this.loadLinealChannels = this.loadLinealChannels.bind(this);
    this.isLinealChannelsLoaded = false;
    try {
      // CARGA DE LAS DISTINTAS EXPERIENCIAS COMO: TIMESHIFT, EPG, MULTIPLE AUDIO, ETC.
      LoadExperience.init();
    } catch (error) {
      console.log('[NEPG]-error', error);
    }

    this.autologinAnalyticsEvent = createAsyncEvent({
      send: event => {
        this.props.setMetricsEvent(event);
        this.props.setMetricsEvent({ type: 'executor' });
      },
      label: AUTOLOGIN_EVENT_LABEL,
      action: AUTOLOGIN_EVENT_ACTION,
      category: AUTOLOGIN_EVENT_CATEGORY,
      successLabel: AUTOLOGIN_EVENT_SUCCESS_LABEL,
      errorLabelPrefix: AUTOLOGIN_EVENT_ERROR_LABEL_PREFIX
    });


    if(Utils.isSTBZTE()) {
      const enterZteFirstTime =  DeviceStorage.getItem('enterZteFirstTime');
      if(!enterZteFirstTime) {
        DeviceStorage.setItem('enterZteFirstTime', 1);
      }
    }

    this.initializeNewRelic();

  }


  initializeNewRelic(){
    NewRelic.setApplicationVersion(pkg.version)
  }



  /**
   * Si hay un resolve del AAF, aquí­ le pega los params
   * con que se envió a playear live a la ruta, por si hay un back
   *
   * @param {*} liveParams
   */
  setAafLiveHistory(liveParams) {
    if (this.lastHistoryHash.key) {
      this.lastHistoryHash.liveparams = liveParams;
      this.aafLiveHistory[this.lastHistoryHash.key] = this.lastHistoryHash;
    }
  }

  /**
   * Listener que escucha por el history back del navegador
   * importante que el history sea browser history
   * import UtilsSearch from '../Search/UtilsSearch';
para que este evento sea lanzado y tenga los mismos
   * hash keys que el react router
   * (también escucha por el clic en botón 'forward' pero
   * este clic 'supone' no se usa, no hay forma de hacerlo con el
   * control remoto, sólo se puede hacer back)
   *
   * @param {*} popEvent
   */
  handlePopState(popEvent) {
    if (Utils.isNullOrUndefined(popEvent.state)) {
      return;
    }
    if (Utils.isNullOrUndefined(popEvent.state.key)) {
      return;
    }

    const node_initial = getNodeFrom()
    const nameNodeClaroSportsGuia = getTextNodeClaroSportsGuia();

    const validatePlayedTvNodeClaroSportGuia = nameNodeClaroSportsGuia.includes(node_initial);

    if(validatePlayedTvNodeClaroSportGuia) return

    const hashBack = popEvent.state.key;
    if (hashBack) {
      if (Utils.isNotNullOrNotUndefined(this.aafLiveHistory[hashBack])) {
        if (this.aafLiveHistory[hashBack].liveparams) {
          console.log('BACK, se lanza player');
          let backPlayerParams = this.aafLiveHistory[hashBack].liveparams;
          // Tomar el último channel que se playeó
          const lastCh = TvChannelUtil.getLastChannel();
          if (lastCh) {
            backPlayerParams.source.videoid = lastCh;
          }
          if (Utils.isNotNullOrNotUndefined(backPlayerParams.streamContentType)) {
            switch (backPlayerParams.streamContentType) {
              case AAF_CONTENT_IS_STARTOVER:
              case AAF_CONTENT_IS_TIMESHIFT:
                const pParams = {
                  playerstate: backPlayerParams.playerstate,
                  source: backPlayerParams.source,
                  ispreview: false,
                  islive: true,
                  ispip: false,
                  size: {
                    top: 0,
                    left: 0,
                    width: 1280,
                    height: 720
                  },
                  event: null
                };
                backPlayerParams = pParams;
                break;
              default:
                break;
            }
          }

          this.props.playFullMedia(backPlayerParams);
          LayersControl.showPlayer();
        }
      }
    }
  }

  async checkStatusPin() {
    // Mandar a llamar la los canales bloqueados se debe hacer siempre al inicio de la aplicación
    // indendiente de si hay llave en metadata que habilite el checking de canales críticos
    try {
      let blockedChannels = await AAF.Pin.updateStatusControlPin();
      this.blockedChannels = blockedChannels;
    } catch (e) {
      //console.log('[AAF_FWK] App/index > checkStatusPin hubo error al ir por statuscontrolpin al iniciar la app');
    }

    // Si además hay llave en metadata que habilite el checking de canales críticos, se lanza el interval
    if (AAF.Pin.useChannelRatingFlow()) {
      AAF.Pin.startLoopRefreshBlockedChannels();
    }
  }

  now() {
    return Utils.now(true);
  }

  favoriteChannelsRequest(service) {
    const level_request = RequestManager.addRequest(service)
      .then(resp => {
        //seteando el estado diná¡micamente
        console.log('EDM: respuesta channels', resp);
        this.setState({ myChannels: resp.response.groups });
      })
      .catch(err => {
        console.error(err);
      });
  }

  clearTimeOutAAF = () => {
    if(this.timeOutAAF && typeof this.timeOutAAF.clear === 'function' && Utils.isTimeoutAvailable()){
      this.timeOutAAF.clear();
    }
  }

  startTimeOutAAF= () => {
    this.timeOutAAF = Utils.isTimeoutAvailable() ? new TimeOutAAF(this.props) : null;
  }

  componentWillMount() {
    this.autologinAnalyticsEvent.start();
    this.props.fetchIsLoggedIn(FROM_APP)
      .then(async () => await this.showLandingTVEverywhere())
      .then(this.isLoggedInCallback)
    if(Device.getDevice().getPlatform() === 'arris' && Utils.isTimeoutAvailable()){
      this.startTimeOutAAF();
    }

    this.unlisten = this.history.listen((location, action) => {
      const {pathname} = location || {};
      NewRelic.setCurrentRouteName(pathname);
    });
  }

  setMetricsEvent(payload) {
    this.props.setMetricsEvent(payload);
  }

  fillFullChannels(data) {
    if (this.device === 'nagra') {
      let firstPlayString =
        '{"src":"tv://channel.00a0001f0003","muted":false,"drmInfo":{"server_url":null,"challenge":null,"content_id":"744612","device_id":"245705069313"},"autoPlay":true,"isLive":true,"isActiveEpg":"true","groupId":"758375","streamType":"dvbc"}';

      this.channelJSON = data.map(x => {
        if (TvChannelUtil.getLastChannel() === x.group_id)
          firstPlayString = firstPlayString.replace(
            'tv://channel.00a0001f0003',
            x.channel_url
          );
        return x.group_id;
      });

      if (
        this.props.playFullMedia &&
        window.location.href.indexOf(CLARO_MUSICA_NODE) === -1 &&
        window.location.href.indexOf('player') === -1
      ) {
        this.props.playFullMedia(JSON.parse(firstPlayString));
      }
    }
  }

  changePath(newpath, extradata) {
    this.history.push(newpath, extradata);
    let hidePlayer = true;
    if (Utils.isPipAvailable()) {
      if (newpath.indexOf('endplayer') != -1 || newpath.indexOf('epg') != -1) {
        hidePlayer = false;
      }
      console.log('SHX app index changepath', hidePlayer);
      LayersControl.showUX(hidePlayer);
    }
  }

  onSomeEvent = e => {
    //new messages
    const popup = this.CCOM.ConditionalAccess.getIrdPopupMessage();
    const msg = popup.popupInfo.message;

    //Aqui va el popup
  };

  handleFavBtn = region => {
    if (region == null) {
      this.checkStatusPlaying();
      const links = this.getLinks();
      const targetNode = links.miscontenidos || links.home;
      this.setResumeDataEmpty();
      this.changePath(`/node/${targetNode}`);
      console.log('SHX app index handleFavBtn');
      LayersControl.showUX();
      return true;
    }
    switch (region) {
      default:
        break;
    }
    return false;
  };

  checkStatusPlaying = () => {
    console.log('AAFPlayer', AAFPlayer.devicePlayerParams);
    let Clone = {};
    Object.assign(Clone, AAFPlayer.devicePlayerParams);
      Clone = {
        playerstate: 'STOPPING',
        ispip: false
      };

    this.props.playFullMedia(Clone);
  };

  setResumeDataEmpty = () => {
    return;
  };

  handlePPVBtn = region => {
    if (region == null) {
      this.checkStatusPlaying();
      const links = this.getLinks();
      const targetNode = links.ppv || links.home;
      this.setResumeDataEmpty();
      this.changePath(`/node/${targetNode}`);
      LayersControl.showUX();
      return true;
    }
    switch (region) {
      default:
        break;
    }
    return false;
  };

  handleDelayKey(e, key) {
    if (this.lastKey !== key && this.delayTimerId) {
      clearTimeout(this.delayTimerId);
    }

    this.isKeysBloqued = this.lastKey === key && this.delayTimerId;
    this.lastKey = key;

    if (this.isKeysBloqued) {
      e.stopPropagation();
      e.preventDefault();
    } else {
      const _this = this;
      this.delayTimerId = setTimeout(() => {
        clearTimeout(_this.delayTimerId);
        _this.delayTimerId = null;
      }, this.delayKeyTime);
    }
  }

  /*
   * TODO I dont know Rick, this must an abstraction in case to be needed
   */
  onAndroidKeyEvent(e) {
    const event_data = e.detail;
    const isAuthdevice = window.location.pathname.includes('/authdevice');

    console.info('[App] onAndroidKeyEvent', event_data.param, event_data.event, e);

    if (isAuthdevice){
      e.stopPropagation();
      e.preventDefault();
      return;
    }

    const param = event_data.param;

    let keyCode = Number.parseInt(param);
    let el = document.activeElement || document.body;

    // Create the event
    const eventObj = document.createEventObject
      ? document.createEventObject()
      : document.createEvent('Events');

    if (eventObj.initEvent) {
      eventObj.initEvent('keydown', true, true);
    }

    eventObj.keyCode = keyCode;
    eventObj.which = keyCode;

    el && el.dispatchEvent ? el.dispatchEvent(eventObj) : el.fireEvent('onkeydown', eventObj);
  }

  handleKeyPress(e) {
    const altura = document.querySelector('.ribbongrid-wrapper');
    if(altura && altura.offsetHeight === 614){
        document.querySelector('.ribbongrid-wrapper').style.height = '814px';
    }

    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;

    //Reset búsqueda guardada en storage
    !this.history.location.pathname.includes("vcard")
    && !this.history.location.pathname.includes("search")
    && UtilsSearch.updateDataStoreSearcher({wordsSearch: ""})

    //Setting para modal ¿Sigues aquí?/////////
    handleOnKeyPressModalInactivity()

    ////////////////////////

    console.log('[App] handleKeyPress', currentKey, e.keyCode);
    if (Utils.isModalEpgVersionOpen()) {
      return;
    }
    if (!Utils.isNotificationHide() && Utils.modalType() !== MODAL_INACTIVITY) {
      // Se permite la propagación del evento si la notificación tiene botones y la tecla es LEFT o RIGHT
      // para que el evento llegue a SpatialNavigation y se pueda navegar entre botones.
      const validNavigationKeysForNotification = ["LEFT", "RIGHT"]
      if(!document.querySelector("#notification-shortcut-button") || !validNavigationKeysForNotification.includes(currentKey)) {
        e.preventDefault();
        e.stopPropagation();
      }

      return;
    }
    /* TODO handleDelayKey Abstract for every device */
    const pathname = window.location.pathname.split('/');

    this.timeOutAAF && this.timeOutAAF.handleKeyPress();

    if (Utils.keyBloquedInPTV(pathname, currentKey)) {
      return;
    }

    this.handleDelayKey(e, currentKey);

    let id;

    if (pathname.length > 0) id = pathname[2];
    const lastChannel = TvChannelUtil.getLastChannel();
    const lastChannelIndex =
      lastChannel != 'undefined' ? this.channelJSON.indexOf(lastChannel) : -1;
    const channelIndex =
      lastChannelIndex != -1 ? lastChannelIndex : this.esteCanal == -1 ? 0 : this.esteCanal; //this.channelJSON.indexOf(id)
    let playerState = AAFPlayer.getCurrentPlayingState(false);
    let playerOptions = AAFPlayer.getCurrentPlayerOptions(false);
    let newChannelIndex;
    const androidShowReloadDialog = () => {
      try {
        if (
          window.AndroidPlayerInterface &&
          window.AndroidPlayerInterface.showReloadDialog
        ) {
          let reloadLabel = Translator.get('stbreload', 'Recargar');
          let settingsLabel = Translator.get('stbsettings', 'Ajustes');
          window.AndroidPlayerInterface.showReloadDialog({ reloadLabel, settingsLabel });
        }
      } catch (e) {
        console.error('[App] handleKeyPress androidShowReloadDialog', e);
      }
    };
    if (this.device === 'arris') {
      const inactiveButtons = ['CH_DOWN', 'CH_UP', 'MENU', 'GUIDE'];
      if (inactiveButtons.includes(currentKey)) {
        console.error('[App] Key not activated');
        e.preventDefault();
        e.stopPropagation();
        return;
      }
    }
    if (currentKey === 'INFO') {
      const {type = OTT} = this.props.user;
      if (type === OTT) {
        androidShowReloadDialog();
      }
    }

    if (currentKey === 'HELP') {
      const buttons = [
        {
          content: Translator.get('btn_modal_ok', 'Aceptar'),
          props: {}
        }
      ];

      const contentModal = Translator.get(
        'lbl_btn_help',
        'Si tenés consultas sobre tu servicio de TV comunicate con nosotros al 0-800-123-0611'
      );
      const asset = Asset.get('ic_info_alert', '');
      const title = Translator.get('lbl_title_help', 'AYUDA');

      const modal = {
        modalType: MODAL_GENERIC,
        modalProps: {
          content: contentModal,
          asset,
          title,
          buttons,
          buttonsAlign: 'vertical'
        }
      };

      this.props.showModal(modal);

      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if (currentKey === 'HD') {
      if(AAFPlayer.getCurrentStreamContentType() !== AAF_CONTENT_IS_TV) {
        HidePlayerControlsObserver.fire()
      }

      let nodeTV = new ActivesSingleton().getTvNode();
      this.history.push('/node/' + nodeTV);
      Utils.hideSkipIntro();
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if (currentKey === 'MSG') {
      this.props.showNotification({
        show: true,
        title: Translator.get('not_available_function', 'Función no disponible'),
        faClass: 'fa-asterisk',
        type: 'message'
      });
    }

    if (currentKey === 'CH_DOWN' && window.location.href.indexOf('player') !== -1) {
      if (this.device === 'nagra') {
        newChannelIndex =
          channelIndex == 0 ? this.channelJSON.length - 1 : channelIndex - 1;
        console.log(
          'json[this.channelJSON[newChannelIndex]]',
          json[this.channelJSON[newChannelIndex]]
        );
        this.esteCanal = newChannelIndex;
        let newS = {
          src: json[this.channelJSON[newChannelIndex]], // new url to replace current and play
          drmInfo: { server_url: null, content_id: null, challenge: null }, // reset to null (we are un DBVC), just in case...
          streamType: 'dvbc', // see playerConstants
          isLive: true,
          isActiveEpg: false,
          groupId: this.channelJSON[newChannelIndex]
        };

        let srcArray = newS.src.split('.');

        let eventObject = PPE.getEventCurrent(srcArray[1]);
        console.log('[eventObject.eventId]', eventObject.eventId);

        let purchasableObject = PPE.getPurchasableObject(eventObject);
        console.log('[purchasableObject]', purchasableObject);

        if (!purchasableObject) {
          if (this.blockedChannels.length > 0) {
            if (this.blockedChannels.indexOf(newChannelIndex) !== -1) {
              console.log('EDM: group id a setear', newChannelIndex);
              this.props.showModal({
                modalType: MODAL_PIN,
                modalProps: {
                  action: 'MP_CHECAR_STATUS',
                  successCallBack: newS => {
                    this.props.replaceFullSourceMedia(newS);
                  }
                }
              });
            } else {
              this.props.replaceFullSourceMedia(newS);
            }
          } else {
            this.props.replaceFullSourceMedia(newS);
          }
        } else {
          this.props.showModal({
            modalType: MODAL_PPE,
            modalProps: {
              callback: a => {
                if (PPE.initiatePPVEventPurchase())
                  this.props.replaceFullSourceMedia(newS);
              }
            }
          });
        }
      }
    }

    if (currentKey === 'CH_UP' && window.location.href.indexOf('player') !== -1) {
      if (this.device == 'nagra') {
        newChannelIndex =
          channelIndex == this.channelJSON.length - 1 ? 0 : channelIndex + 1;
        this.esteCanal = newChannelIndex;
        console.log(
          'json[this.channelJSON[newChannelIndex]]',
          json[this.channelJSON[newChannelIndex]]
        );
        let newS = {
          src: json[this.channelJSON[newChannelIndex]], // new url to replace current and play
          drmInfo: { server_url: null, content_id: null, challenge: null }, // reset to null (we are un DBVC), just in case...
          streamType: 'dvbc', // see playerConstants
          isLive: true,
          isActiveEpg: false,
          groupId: this.channelJSON[newChannelIndex]
        };

        if (newS.src && newS.src != '') {
          let srcArray = newS.src.split('.');

          let eventObject = PPE.getEventCurrent(srcArray[1]);
          console.log('[eventObject.eventId]', eventObject.eventId);

          let purchasableObject = PPE.getPurchasableObject(eventObject);
          console.log('[purchasableObject]', purchasableObject);

          if (!purchasableObject) {
            if (this.blockedChannels.length > 0) {
              if (this.blockedChannels.indexOf(newChannelIndex) !== -1) {
                console.log('EDM: group id a setear', newChannelIndex);
                this.props.showModal({
                  modalType: MODAL_PIN,
                  modalProps: {
                    action: 'MP_CHECAR_STATUS',
                    successCallBack: newS => {
                      this.props.replaceFullSourceMedia(newS);
                    }
                  }
                });
              } else {
                this.props.replaceFullSourceMedia(newS);
              }
            } else {
              this.props.replaceFullSourceMedia(newS);
            }
          } else {
            this.props.showModal({
              modalType: MODAL_PPE,
              modalProps: {
                callback: a => {
                  if (PPE.initiatePPVEventPurchase())
                    this.props.replaceFullSourceMedia(newS);
                }
              }
            });
          }
        }
      }
    }

    if (currentKey === 'PPV') {
      this.handlePPVBtn(null);
    }

    if (currentKey === 'EXIT') {
      if (this.device === 'arris') {
        Utils.closeArrisSession();
      }
    }

    // TODO separar para nagra? en nagra PREV = BACK?
    if (currentKey === 'PREV' && playerOptions.islive) {
    }

    if (currentKey === 'FAV') {
      if (this.handleFavBtn(null)) {
        //empty
      }
      // preserving code from colombia
      else if (
        this.swapPin <= this.state.myChannels.length - 1 &&
        window.location.href.indexOf('player') !== -1
      ) {
        console.log('EDM: Canal favorito seteado', this.state.myChannels[this.swapPin].id);
        console.log(
          'json[' +
          this.state.myChannels[this.swapPin].id +
          ']' +
          json[this.state.myChannels[this.swapPin].id]
        );

        let newS = {
          src: json[this.state.myChannels[this.swapPin].id], // new url to replace current and play
          drmInfo: { server_url: null, content_id: null, challenge: null }, // reset to null (we are un DBVC), just in case...
          streamType: 'dvbc', // see playerConstants
          isLive: true,
          isActiveEpg: false,
          groupId: this.state.myChannels[this.swapPin].id
        };
        if (newS.src && newS.src !== '') {
          if (newS.src && newS.src !== '') {
            let srcArray = newS.src.split('.');

            let eventObject = PPE.getEventCurrent(srcArray[1]);
            console.log('[eventObject.eventId]', eventObject.eventId);

            let purchasableObject = PPE.getPurchasableObject(eventObject);
            console.log('[purchasableObject]', purchasableObject);

            if (!purchasableObject) {
              if (this.blockedChannels.length > 0) {
                if (this.blockedChannels.indexOf(newChannelIndex) !== -1) {
                  console.log('EDM: group id a setear', newChannelIndex);
                  this.props.showModal({
                    modalType: MODAL_PIN,
                    modalProps: {
                      action: 'MP_CHECAR_STATUS',
                      successCallBack: newS => {
                        this.props.replaceFullSourceMedia(newS);
                      }
                    }
                  });
                } else {
                  this.props.replaceFullSourceMedia(newS);
                }
              } else {
                this.props.replaceFullSourceMedia(newS);
              }
            } else {
              this.props.showModal({
                modalType: MODAL_PPE,
                modalProps: {
                  callback: a => {
                    if (PPE.initiatePPVEventPurchase())
                      this.props.replaceFullSourceMedia(newS);
                  }
                }
              });
            }
          }
        }
        this.swapPin++;
      } else if (window.location.href.indexOf('player') !== -1) {
        this.swapPin = 0;
      }
    }

    if (currentKey === 'BACK') {
      let currentStore = store.getState();

      e.preventDefault();
      const initialRoute = AdsUtils.isAdsEnable() ? this.getInitialRouteAdsExperience() : this.getInitialRoute();

      if (
        window.location.href.indexOf(initialRoute) > -1 &&
        (AAFPlayer.livePlayingAsPip() || !LayersControl.isPlayerVisible())
      ) {
        //el modal exit solo se debe demostrar cuando el player no esta visible (caso smart tvs)
        console.log('this.device ====', this.device);
        if (
          Utils.getRegionaliazedMetadata('show_modal_exit', '{"default":{"enable":true}}')
            .enable
        ) {
          this.props.showModal({ modalType: MODAL_EXIT });
        }
      } else if (LayersControl.isPlayerVisible()) {
        this.setResumeDataEmpty();
        /**
         * Si el player está visible (probablemente pip) pero hay algún error => player está en stopping (No en PLAY state), se debe permitir el back
         *
         * Se deja en blanco para que playerControls haga el back en caso de ser necesario.
         */
        if (AAFPlayer.getCurrentPlayingState(false) === AAFPLAYER_STOP) {
          // Si esta visible el player pero esta en stop, solo se oculta
          LayersControl.hidePlayer(true);
        } else if (
          AAFPlayer.getCurrentPlayingState(false) === AAFPLAYER_PLAY &&
          window.location.href.indexOf('/search') > -1
        ) {
          this.wasBackFromFull = true;
        }
      } else if (
        window.location.href.indexOf(`/${settings.path_suscription}`) > -1 ||
        window.location.href.indexOf('/profile') > -1
      ) {
        return false;
      }
      else if (
        window.location.href.indexOf('/register') > -1 ||
        window.location.href.indexOf('/login') > -1 ||
        window.location.href.indexOf('/password-reminder') > -1 ||
        window.location.href.indexOf('/payment-hubgate') > -1
        ) {
      }
      else if (window.location.href.indexOf('/vcard') === -1) {
        this.history.goBack();
      } else if (
        currentStore.player.playerstate === 'PLAYING' &&
        currentStore.player.source &&
        currentStore.player.source.audiosource
      ) {
        //Si el player de musica esta activo
        this.history.goBack();
      }
    }

    if (currentKey === 'GUIDE' || currentKey === 'MOSAIC') {

      Utils.setIsFromSearch(Utils.isInSearchPage());

      Utils.hideSkipIntro();
      this.closeModalLang();
      let sendToTv = false;
      if (
        LayersControl.isPlayerVisible()
        // playerState === AAFPLAYER_PLAY &&
        // playerOptions &&
        // playerOptions.size &&
        // playerOptions.size.width &&
        // playerOptions.size.width == 1280
      ) {
        //console.log('==> Esta reproduciendo, no hacer nada');
        // Si esta reproduciendo y es VOD, se cambia a tv

        const playingIsNotTV = playerOptions.streamContentType === AAF_CONTENT_IS_VOD
            || playerOptions.streamContentType === AAF_CONTENT_IS_NPVR
            || playerOptions.streamContentType === AAF_CONTENT_IS_AUDIO
            || playerOptions.streamContentType === AAF_CONTENT_IS_RADIO;

        if (
          playingIsNotTV &&
          (playerOptions.source.videoid || playerOptions.source.videosource)
        ) {
          sendToTv = true;
        }
      } else {
        sendToTv = true;
      }
      let isPip = AAFPlayer.livePlayingAsPip();

      if (sendToTv) {
        e.preventDefault();
        e.stopPropagation();
        //console.log('==> Aqui manda a player ', currentKey);
        let tv = this.getLinks().clarotv;
        console.log('getLinks clarotv', tv)

        this.history.push('/node/' + tv + '?epgtype=' + currentKey + '&isPip=' + isPip);
      }
    }

    /* TODO this device (nagra) particular code should not be here */
    if (this.device === 'nagra' && currentKey === 'VOL_UP') {
      ControlVolume.up();

      //  this.setState({vol: ControlVolume.get()});

      if (this.refs.VolInd) {
        this.refs.VolInd.refs.fill.style.height = ControlVolume.get() + '%';
      }

      document.getElementById('volume-indicator').classList.remove('show-vol');
      document.getElementById('volume-indicator').classList.add('show-vol');

      if (this.timerVolId) clearTimeout(this.timerVolId);

      this.timerVolId = setTimeout(function() {
        document.getElementById('volume-indicator').classList.remove('show-vol');
      }, 3000);
    }

    if (this.device === 'nagra' && currentKey === 'VOL_DOWN') {
      ControlVolume.down();
      // this.setState({vol: ControlVolume.get()});
      if (this.refs.VolInd) {
        this.refs.VolInd.refs.fill.style.height = ControlVolume.get() + '%';
      }

      document.getElementById('volume-indicator').classList.remove('show-vol');
      document.getElementById('volume-indicator').classList.add('show-vol');

      if (this.timerVolId) clearTimeout(this.timerVolId);

      this.timerVolId = setTimeout(function() {
        document.getElementById('volume-indicator').classList.remove('show-vol');
      }, 3000);
    }

    if (this.device === 'nagra' && currentKey === 'MUTE') {
      let isMute = ControlVolume.mute();
      console.log('estamos en mudo?', isMute);
      if (isMute > 0) {
        document.getElementById('volume-indicator').classList.add('show-vol');
        document.getElementById('mute-indicator').classList.remove('show-vol');

        setTimeout(function() {
          document.getElementById('volume-indicator').classList.remove('show-vol');
        }, 3000);
      } else {
        document.getElementById('volume-indicator').classList.remove('show-vol');
        document.getElementById('mute-indicator').classList.add('show-vol');
      }
    }

    if (currentKey === 'VOD') {
      if (ThirdPartyEpgHelper.getAAFTPAState() !== null) {
        ThirdPartyEpgHelper.setAAFTPAState(null);
      }

      const currentPathName = window.location.pathname;
      const targetPath = `/node/${this.getLinks().home}`;
      const isHomeNode = (targetPath === currentPathName);

      const currentPlayerOptions = AAFPlayer.getCurrentPlayerOptions();

      if (isHomeNode && currentPlayerOptions.playerstate !== AAFPLAYER_PLAY){
        return false;
      }
      this.checkStatusPlaying();
      this.setResumeDataEmpty();
      this.history.push(targetPath);
      LayersControl.showUX(true);
  }

    if (this.device === 'nagra' && currentKey === 'MENU') {
      console.log('EDM: redireccionando a nodo:', this.getLinks().home);
      this.history.push(`/node/${this.getLinks().home}`);
    }

    if (currentKey === 'MUSIC') {
      if (this.device === 'nagra') {
        const navVisibility = JSON.parse(Metadata.get('nav_visibility'));
        const filteredNodes = navVisibility.filter(node => node.code === CLARO_MUSICA_NODE);
        const user = this.props.user;
        const isAnonymous = user.isAnonymous;
        const isSusc = user.isSusc;
        let shouldBeVisible = true;

        if (filteredNodes.length > 0) {
          if (isAnonymous) {
            shouldBeVisible = filteredNodes[0].anonymous;
          } else if (isSusc) {
            shouldBeVisible = filteredNodes[0].susc;
          } else if (!isSusc) {
            shouldBeVisible = filteredNodes[0].no_susc;
          }
        }

        if (shouldBeVisible) {
          console.log('EDM: redireccionando a nodo:', this.getLinks().music);
          document.dispatchEvent(new CustomEvent(settings.show_epg, { detail: false }));
          this.history.push(`/node/${this.getLinks().music}`);
        }
      } else
        this.props.showNotification({
          show: true,
          title: Translator.get('not_available_function', 'Función no disponible'),
          faClass: 'fa-asterisk',
          type: 'message'
        });
    }

    if (this.device === 'nagra' && currentKey === 'ON_OFF') {
      if (this.turn) {
        this.turn = !this.turn;
        FrontPanel.standByBox();
      } else {
        this.turn = !this.turn;
        FrontPanel.turnOnBox();
      }
    }

      if(ThirdPartyEpgHelper.getAAFTPAState() === TPA_WAS_FIRED) {
        ThirdPartyEpgHelper.setAAFTPAState(null);
      }
  }

  closeModalLang() {
    if (!Utils.isModalHide() && Utils.modalType() === MODAL_LANGUAGES) {
      store.dispatch({
        type: HIDE_MODAL,
        modalType: MODAL_LANGUAGES
      });
    }
  }

  getLinks() {
    return getLinksFromNavConfiguration();
  }

  handleKeyUp(e) {
    if (this.delayTimerId) {
      clearTimeout(this.delayTimerId);
      this.lastKey = null;
      this.delayTimerId = null;
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyPress);
    document.removeEventListener('keyup', this.handleKeyUp);
    document.removeEventListener('AndroidKeyEvent', this.onAndroidKeyEvent);
    clearInterval(this.notificationRecordingsId);
    this.unlisten();
    LiveObserver.unsubscribe(this.chargeLiveComponents);
  }

  async preloadLandingTelmexImages() {
    // Precargar imágenes del landing Telmex para que queden en caché
    if (!isLandingTelmexEnabled())  return
    const {carousel_config} = Utils.getRegionaliazedMetadata('landing_telmex_config', '{carousel_config: {enable:false}}');
    const images = (carousel_config && carousel_config.enable) ?  this.extractImagesFromResponse(await getDynamicImage()) : getImageFromAsset();
    const promisesImages = promiseImageLoad(images)
    preloadImage(promisesImages);
  }

  extractImagesFromResponse(response) {
    const images = []
    for(const item of response) {
      images.push(item.image_background_landscape);
      images.push(item.image_card_landscape);
    }
    return images;
  }

  componentDidMount() {
    // popstate funciona sobre window
    window.addEventListener('popstate', this.handlePopState);
    document.addEventListener('keyup', this.handleKeyUp);
    LiveObserver.subscribe(this.chargeLiveComponents);
    PlayerControlsLogic.intervalValuesMetadata()
    if (
      this.CCOM &&
      this.CCOM.ConditionalAccess &&
      this.CCOM.ConditionalAccess.addEventListener
    ) {
      CCOM.ConditionalAccess.addEventListener('onIrdPopupNew', this.onSomeEvent);
    }

    const showModal = this.props.showModal;
    const history = this.history;
    // TODO do same for PS4....callback access function
    document.addEventListener('keydown', this.handleKeyPress);

    // Add Android Key event listener. Unused?
    document.addEventListener('AndroidKeyEvent', this.onAndroidKeyEvent);

    const channel = { id: '746478', proveedor_name: 'FOX' };

    // Starting loop...to check for network connection
    new DeviceNetworkStatus({ showModal }).startCheckNetwork();
    let localDevice = this.device;
    if (this.device === 'ps4' || this.device === 'iwedia') {
      document.addEventListener(
        'focus',
        e => {
          if (document.getElementById(e.srcElement.id))
            document
              .getElementById(e.srcElement.id)
              .classList.add(localDevice === 'ps4' ? 'on-focus-ps4' : 'on-focus');
        },
        true
      );

      document.addEventListener(
        'blur',
        e => {
          if (document.getElementById(e.srcElement.id))
            document
              .getElementById(e.srcElement.id)
              .classList.remove(localDevice === 'ps4' ? 'on-focus-ps4' : 'on-focus');
        },
        true
      );
    }
    this.getSTBAPKVersion();
    
    // Precargar imágenes del landing para que estén en caché
    this.preloadLandingTelmexImages();
  }

  setStopRender() {
    this.stopRender = false;
  }


  getSTBAPKVersion() {
      let ua = navigator.userAgent;
      let apkversion = null;
      if(ua) {
          let re = /(\d{3,})$/g;
          let res = re.exec(ua);
          if(res && res[1]) {
              apkversion = parseInt(res[1]);
          }
      }
      //youbora
      window.youboraParams[12].value = apkversion || '';
  }

  async getNavData(user) {
    const isIPTV = Resilence.isPTVUSer();

    const {isLoggedIn} = user || {}
    console.log('[getNavData] isLoggedIn', isLoggedIn);

    this.getConfigRemoteControl();
    new AnalyticsDimensionSingleton(user);
    if(this.state.nodes.length >= 0){
      const nodes = store.getState().navbar.nodes;
      this.registerClaroMusicaNode(this.findNode(Utils.filterNavNodes(nodes), CLARO_MUSICA_NODE));
      this.setState({
        nodes: nodes,
        isFetching: false,
        focusReady: true
      });
    }
    DeviceStorage.unsetItem('resetCount');
    DeviceStorage.setItem('successfulAppLoad', true);
    !isIPTV && UtilsIsLoggedIn.setIntervalIsLoggedIn(this.history);
    !isIPTV && UtilsIsLoggedIn.setIntervalValidatorTimer();
    isLoggedIn && UtilsIsLoggedIn.setIntervalSuspendedAccount();
    UtilsEPG.setIntervalEpgClearCache();
  }

  async stickySuccess(stickyResponse, user, cb) {
    const user_mail_validation = Utils.getApaMetadataKey('user_mail_validation', '{"enable":false,"limit":3}');
    const pushSession = Utils.getApaMetadataKey('sticky_session', '{"push_session":false,"user_id":false}', 'push_session');

    // Si no existe el user_id en isLoggedIn
    if (!DeviceStorage.getItem('user_id') && pushSession && user.isLoggedIn && !DeviceStorage.getItem('isIptv')) {
      DeviceStorage.setItem('user_id', user.user_id);
      await isLoggedIn().then(result => {
        const user = result.response ? result.response : {};
        if (user && user.user_id) {
          DeviceStorage.setItem('user_id', user.user_id);
          NewRelic.setUserId(user.user_id);
        }
        store.dispatch(receiveIsLoggedIn(user));
      });
    }

    // Si ya existe user_id en el storage
    if (DeviceStorage.getItem('user_id') && user && user.user_id && pushSession) {
      DeviceStorage.setItem('user_id', user.user_id);
      NewRelic.setUserId(user.user_id);
      this.checkStatusPin();
    }

    if (
      user &&
      user.is_user_logged_in &&
      !user.validEmail &&
      !Utils.isPTV(this.props.user) &&
      user_mail_validation.enable === true
    ) {
      const modal = {
        modalType: MODAL_UPDATE_EMAIL
      };
      this.props.showModal(modal);
    }
    await this.getNavData(user);

    if(typeof cb === 'function'){
      cb();
    }
  }

  findNode(nodes, code) {
    return nodes.find((node)=>node.code === code);
  }

  registerClaroMusicaNode(claroMusica){
    if (claroMusica) {
      Utils.setHasClaroMusicaNode(true);
    }else {
      Utils.setHasClaroMusicaNode(false);
    }
  }

  async callbackAfterLoginInProfile(cb){
    await this.getNavData(this.props.user);

    if(typeof cb === 'function'){
      cb();
      LoadingIptvOttFlow.setIsEnabled(true);
      RibbonsObserver.fire(true);
    }
  }

  async startEpgChecker(){
    const checker = new EpgVersionStatus(this.updateApp);
    checker.startCheckLinealChannels();
    await checker.startCheckVersion(this.setStopRender);
  }

  getReminders(user) {
    if (user.isLoggedIn && this.toggleFunctions.reminders_notification) {
      ReminderNotifications.setIntervalRemindersSync(
        parseInt(Metadata.get('sentinel_reminders_interval', 30)),
        (values, handleRedPress, handleGreenPress) => {
          this.props.showEventReminderNotification(values, handleRedPress, handleGreenPress);
        },
        (lasttouch) => {
          this.props.setLastTouchReminder(lasttouch)
        },
        ( params ) => {
          this.props.playFullMedia(params);
        },
        (props) => {
          this.props.hideNotification(props);
        }
      );
    }
  }

  getRecordings(user) {
    if (
      this.toggleFunctions.reminders_notification_npvr &&
      !NpvrUtil.recordingIconEnable().enable
    ) {
      new RecordingSingleton(user);
      clearInterval(this.notificationRecordingsId);
      this.notificationRecordingsId = setInterval(
        () => new Npvr().notificationHandler(),
        this.timerNotificationRecordings
      );
    }
  }

  async EpgDataLoading(user, nodes){
    const { fetchLinealChannels } = this.props;
    this.favoriteChannelsRequest(this.myChannels);

    await fetchLinealChannels(user.user_id, () =>{
      new ChannelSingleton(user, nodes);
    });

    if (NpvrUtil.recordingIconEnable().enable && !user.isAnonymous) {
      NpvrUploader.setUser(user);
      NpvrUploader.setShowNotification(this.props.showNotification);
      NpvrUploader.start();
    }
    if (EpgPersistence.isDatabaseDataSource()) {
      await new EpgFeederManager().boot();
    }else{
      // Entra el flujo de apis.
      new EpgFeederManager().updateRecordings();
    }
    if (user.isLoggedIn) {
      this.getRecordings(user);
    }
  }

  async chargeLiveComponents(){
    const { user } = this.props;
    this.getReminders(user);
    // Carga de favoritos
    LoadFav.start();

    LoadingIptvOttFlow.setIsLoadLive(true);
    LiveObserver.unsubscribe(this.chargeLiveComponents);
  }

  async loadLinealChannels() {
    if (!this.isLinealChannelsLoaded) {
      const { user } = this.props;
      const { nodes } = this.state;
      await this.startEpgChecker();
      await this.EpgDataLoading(user, nodes);
      this.isLinealChannelsLoaded = true;
    }
  }

  checkIfShowAlert(user) {
    if(!this.showAlert){
      const {isSusc, isLoggedIn, type = OTT} = user;
      if (UtilsIsLoggedIn.showBlueHeadBand()){
        this.showAlert = true;
      }
      else if(type === OTT && isLoggedIn && !isSusc){
        this.showAlert = true;
      }
    }
    this.props.user.checkShowAlert = false;
  }

   showPrivacyPolicyModal(cb){

    UtilsIsLoggedIn.showPrivacyPolicyModal((accepted) => {
      if (accepted) {
        //Actualizar el estado
        store.dispatch(setAacceptedTerms(1));
        this.setState({
          isFetching: false,
          focusReady: true
        });
      }

      if ('function' === typeof cb) cb();

    })
  }

  showSuspendedAccountModal(){
    this.setState({
      isFetching: false,
      focusReady: true
    });
    this.history.push('/suspended-account')
    UtilsIsLoggedIn.setIntervalSuspendedAccount();
    const modal = {
      modalType: AAF_MODAL_SUSPENDED_ACCOUNT,
      modalProps: { buttonsAlign: 'vertical' , ...getSuspendedAccountLabels()}
    };
    this.props.showModal(modal);
  }

  isActiveContinueProcessLoginByToken() {
    const user = store.getState().user;
    console.log('[App]:: user:::::', user);
    const activeProcessLoginBytoken = user && user.activeProcessLoginBytoken;
    console.log('[App]:: isActiveContinueProcessLoginByToken:::::', activeProcessLoginBytoken);

    return activeProcessLoginBytoken;
  }

  async isLoggedInCallback() {
    const isIPTV = Resilence.isPTVUSer();
    let { user } = this.props;
    const code = user && user.errors && user.errors.code ? user.errors.code : '';
    const codeAdvertising = user && user.errors && user.errors[0] ? user.errors[0].code : '';
    const validateCode = (code === LOGIN_RESPONSE_TYPE.ACCEPT_TERMS || codeAdvertising === LOGIN_RESPONSE_TYPE.ACCEPT_TERMS_ADVERTISING);
    console.log('[App]:: isLoggedInCallback:::::', user);

    if (user.accepted_terms === 0 && validateCode) {
      if (user.isSuspendedAccount) {
        this.showPrivacyPolicyModal(this.showSuspendedAccountModal);
      } else {
        this.showPrivacyPolicyModal();

      }
    }

    if (user.isSuspendedAccount && user.accepted_terms === 1) {
      this.showSuspendedAccountModal()
    }

    let sticky_after_authdevice = false;
    const pushSession = Utils.getApaMetadataKey('sticky_session', '{"push_session":false,"user_id":false}', 'push_session');

    new AnalyticsDimensionSingleton().setUser(user);
    /*
     * Se deja la lógica antigua para IPTV en caso de querer mantenerla y se cambia la lógica en caso de OTT.
     * De cualquier manera, dentro de la lógica de OTT, habrá una sección para agregar una versión optimizada
     * de IPTV con el nuevo orden.
     */
    if(user.type === IPTV) {
      LoadingIptvOttFlow.isToogleLevelsDelay() && LoadingIptvOttFlow.setIsEnabled(true);
      /**
       * TODO Por qué no se sincronizó la respuesta del sticky con los siguientes pasos en esta función/método ¿?
       */
      if (pushSession) utilsIsSticky.getPushSession();

      if (user.isLoggedIn) {
        this.autologinAnalyticsEvent.success();
      }

      if (sticky_after_authdevice) {
        // TODO await necesario? en el callback ¿? :/
        utilsIsSticky.getPushSession(this.stickySuccess, user);
      }
      else {
        this.setStopRender();
        await this.stickySuccess(null, user);
      }

      // Set CMR experience interval
      const { enable } = getEnableCMRExperience() || {};
      if (user.isLoggedIn && enable) {
        UtilsCMRExperience.setIntervalCMRExperience(this.history);
      }
    }
    //Se hace hace para no afectar la lógica en caso de ser IPTV
    else {
      this.setStopRender();
      // Lógica de inicio por tipo de sesión
      if(user.isLoggedIn) {
        if (user.isLoggedIn && UtilsProfile.isProfileEnable(user)) {
          if(pushSession) {
            utilsIsSticky.getPushSession(() => {
              this.setState({
                isFetching: false,
                focusReady: true
              }, ()=>{
                const { user } = store.getState();
                if (!user.isSuspendedAccount) {
                  this.history.replace('/profile'); // /profile  `/${settings.path_suscription}`
                }
              });
            });
          }
          else {
            this.setState({
              isFetching: false,
              focusReady: true
            },()=>{
              this.history.replace('/profile'); // /profile  `/${settings.path_suscription}`
            });
          }
        }
        else {
          if (pushSession) utilsIsSticky.getPushSession();
          this.autologinAnalyticsEvent.success();
          await this.stickySuccess(null, user, ()=>{
            LoadingIptvOttFlow.setIsEnabled(true);
            RibbonsObserver.fire(true)}
          );
        }
      }
      else {
        // Si es anónimo, onboarding?
        if (pushSession) utilsIsSticky.getPushSession();

        const DeviceC = Device.getDevice().getConfig();
        if (DeviceC && DeviceC.loadingFlow) {
          switch (DeviceC.loadingFlow) {
            case 'smartcard':
              await this.props.fetchSmartCardLogin();
              user = this.props.user;
              break;
            default:
              break;
          }
        }

        const useFetch = getOnboardingConfig().enable;
        const { enable, loginByToken_retry } = getEnableCMRExperience() || {};

        if (useFetch) {
          //* Se manda al nuevo fetchAuthDeviceCMR
          if (enable) {
            console.log('[App]:: se manda al nuevo fetchAuthDeviceCMR:::::');
            const retriesCMR = parseInt(loginByToken_retry.async, 10);
            console.log('[App]:: retriesCMR:', retriesCMR);

            await this.props.fetchAuthDeviceCMR();

            if (this.isActiveContinueProcessLoginByToken()) {
              for (let i = 0; i < retriesCMR; i++) {
                console.log('[App]:: se manda al nuevo fetchLoginByToken:::::');
                await this.props.fetchLoginByToken();
                user = this.props.user;

                const { isLoggedIn } = user;
                const missingEmail = DeviceStorage.getItem('missingEmail') && DeviceStorage.getItem('missingEmail') === 'true' ? true : false;
                const conditionSuccess = isLoggedIn === true || missingEmail;

                if (conditionSuccess) {
                  this.continueFlowIPTV = true;
                  this.isLoggedInCallback()
                  break;
                }

                this.continueFlowIPTV = false;
              }
            }
          } else {
            console.log('[App]:: se manda al actual fetchAuthDevice:::::');
            const { async = 0 } = getAuthdeviceConfig() || {};
            const retries = parseInt(async, 10);
            console.log('[App]:: retries:::::', retries);

            for (let i = 0; i < retries + 1; i++) {
              await this.props.fetchAuthDevice();
              user = this.props.user;

              const {isLoggedIn} = user;
              const missingEmail = DeviceStorage.getItem('missingEmail') && DeviceStorage.getItem('missingEmail') === 'true' ? true : false;
              const conditionSuccess = isLoggedIn === true || missingEmail;

              if (conditionSuccess) {
                this.continueFlowIPTV = true;
                break;
              }

              this.continueFlowIPTV = false;
            }
          }

          sticky_after_authdevice = pushSession;

          if (user && user.session_userhash) {
            DeviceStorage.setItem('user_hash', user.session_userhash);
          } else {
            if (LoadPtv.isEnableOttExperience() || Utils.isSeirobotics()) {
              //Flujo para cajas que nunca han tenido un login exitoso, mandar a Landing
              this.continueFlowIPTV = true;
            } else {
              const missingEmail = DeviceStorage.getItem('missingEmail') && DeviceStorage.getItem('missingEmail') === 'true' ? true : false;
              if (!missingEmail) {
              //* Flujo mostrar pantalla de reintento
              this.setState({
                isFetching: false,
                focusReady: true
              });
              !isIPTV && UtilsIsLoggedIn.setIntervalIsLoggedIn(this.history);
              //* Se ejecuta el intervalo (24 horas) para mandar a llamar la API V1/authDevice
              UtilsCMRExperience.setIntervalCMRExperience(this.history);
              this.history.replace('/authdevice')
              return;
              }
            }
          }
        }
        this.checkAppkeyForce();
        if (!user || !user.session_userhash) {
          DeviceStorage.unsetItem('user_hash');
        }

        if (sticky_after_authdevice) {
          // TODO await necesario? en el callback ¿? :/
          utilsIsSticky.getPushSession(this.stickySuccess, user);
          const fromAuthDevice = DeviceStorage.getItem('fromAuthDevice') && DeviceStorage.getItem('fromAuthDevice') === 'true' ? true : false;
          const missingEmail = DeviceStorage.getItem('missingEmail') && DeviceStorage.getItem('missingEmail') === 'true' ? true : false;
          if(useFetch && !fromAuthDevice && !missingEmail){
              this.history.replace('/landing');
          }
        } else {
          const esIPTELMEX = user && user.userDetectWS && user.userDetectWS.url;
          if(esIPTELMEX){
            console.log("[App] Modo de acceso: NOT LOGGED IPTELMEX");
            this.history.push('/iptelmex', {
              user: user
            });
          }else{
            console.log("[App] Modo de acceso: NOT LOGGED USER Anonymous");
            if(useFetch){
              this.history.replace('/landing');
            }
          }
          await this.stickySuccess(null, user, ()=>{
            LoadingIptvOttFlow.setIsEnabled(true);
            RibbonsObserver.fire(true);
          });
        }
      }
    }
  }

  getInitialRouteAdsExperience() {
    const { navbar = {} } = store.getState() || {};
    const { nodes = [] } = navbar;
    const sizeOfNodes = nodes.length;
    const homeNode = sizeOfNodes > 0 ? nodes[0].code : Constants.HOMEUSER_LITE;

    return homeNode;
  }

  getInitialRoute() {
    if (!this.continueFlowIPTV) return null;

    //return 'tv'
    const user = this.props.user;
    const configuration = Utils.getApaMetadataKey('nodes_configuration', '{"anonymous":{"default_node":"homeuser"},"no_susc":{"default_node":"homeuser"},"susc":{"default_node":"homeuser"}}', user.userStatus);

    return configuration.default_node;
  }

  getConfigRemoteControl() {
    let rcConfigControl = DeviceStorage.getItem('config_remote_control', rcConfigControl);
    if (!rcConfigControl) {
      rcConfigControl = Utils.getRegionaliazedMetadata(
        'rc_default_config',
        '{"default":{"enable":false,"config":"full"}}'
      ).config;
      if (!rcConfigControl) rcConfigControl = 'full';
    }
    DeviceStorage.setItem('config_remote_control', rcConfigControl);
  }

  switch() {
    this.setState({ orden: !this.state.orden });
    //this.setState({src2:''})
  }

  canUserViewChannel(groupId, provider) {
    const linealChannels = this.props.linealChannels;
    return linealChannels.find(channel => channel.id == groupId);
  }

  checkAppkeyForce() {
    if (this.props.user) {
      if (this.props.user.ptv_url) {
        this.history.push('/ptv');
        return;
      }

      if (this.props.user.subscriptions) {
        if (this.props.user.paymentMethods) {
          if (
            (this.props.user.paymentMethods.hubcorporativofijogate ||
              this.props.user.paymentMethods.hubfijovirtualgate ||
              this.props.user.paymentMethods.hubfacturafijagate ||
              this.props.user.paymentMethods.clarocolombiagate) &&
            LoadPtv.disableTmpByMethod()
          ) {
            if (
              !DeviceStorage.getItem('force_appkey') &&
              Metadata.get('force_appkey', '75c85456ea90fada98103ec1f7ba61ed') !==
              'force_appkey'
            ) {
              DeviceStorage.setItem(
                'force_appkey',
                Metadata.get('force_appkey', '75c85456ea90fada98103ec1f7ba61ed')
              );

              window.location = '/';
            }
          }
        }
      }
    } else if (DeviceStorage.getItem('force_appkey')) {
      DeviceStorage.unsetItem('force_appkey');
      window.location = '/';
    }
  }

  closeModal(modal) {
    store.dispatch(modal);
  }

  refresh() {
    console.log('+++ Refresh ....', this.state.nodes);
    this.setState({
      refresh: true
    });
  }

  updateFavoriteChannels() {
    this.props.fetchFavoriteChannels(this.props.user, MyContentsettings.myChannels);
  }

  updateFavoriteVOD() {
    this.props.fetchFavoriteVOD(this.props.user, MyContentsettings.myFavorites);
  }

  playInit(channelToPlay, params) {
    const region = DeviceStorage.getItem('region');
    let openGuide = JSON.parse(Metadata.get('open_guide', '{}'));
    let openGuideByRegion = false;
    if (Utils.isObject(openGuide) && !Utils.isEmpty(openGuide)) {
      openGuideByRegion = openGuide[region] ? openGuide[region] : openGuide['default'];
    }

    let starttime = null;
    let deleteLastStream = null;
    let playerState = AAFPlayer.getCurrentPlayingState(false);
    if (playerState === AAFPLAYER_PLAY) {
      let playerOptions = AAFPlayer.getCurrentPlayerOptions(false);
      if (playerOptions.source && playerOptions.source.videoid) {
        if (playerOptions.source.videoid == channelToPlay) {
          // Si timeshift el anterior, sólo le pega el starttime
          if (playerOptions.starttime && Utils.isNullOrUndefined(playerOptions.endtime)) {
            starttime = playerOptions.starttime;
          }
          // Si esta reproduciendo un fallback, se mantiene
          if (playerOptions.deleteLastStream) {
            deleteLastStream = playerOptions.deleteLastStream;
          }
        }
      }
    }
    if (params.isPip === 'true' && params.epgtype) {
      delete params.epgtype;
    } else if (!params.epgtype && openGuideByRegion) {
      params.epgtype = 'GUIDE';
    }
    this.props.playFullMedia({
      playerstate: 'PLAYING',
      source: {
        videoid: channelToPlay
      },
      size: {
        top: 0,
        left: 0,
        width: 1280,
        height: 720
      },
      ispreview: false,
      islive: true,
      ispip: false,
      filterTV: null,
      params,
      starttime,
      deleteLastStream
    });
  }

  isNodeTV(location) {
    let nodeTV = new ActivesSingleton().getTvNode();
    return location.pathname.includes(nodeTV);
  }

  ifPromptTVNode(location) {
    // TODO, le pega en performance a stb? huawei por ej?
    let params =
      Utils.urlParamsToJson(location.search) || {};
    let channelToPlay = TvChannelUtil.getLastChannel();
    let existeChannel = ChannelSingleton ? ChannelSingleton.canPlayChannel(channelToPlay) : false;

    if (!channelToPlay || !existeChannel) {
      new ChannelSingleton()
        .getChannels()
        .then(channels => {
          existeChannel = ChannelSingleton ? ChannelSingleton.canPlayChannel(channelToPlay) : false;
          if(existeChannel){
            channelToPlay = TvChannelUtil.getLastChannel()
          }
          else{
            for (let i = 0; i < channels.length; i++) {
              if (
                ChannelSingleton.canPlayChannel(
                  channels[i].group_id
                )
              ) {
                channelToPlay =
                  channels[i].group_id;
                TvChannelUtil.setLastChannel(
                  channelToPlay
                );
                break;
              }
            }
          }
          this.playInit(channelToPlay, params);
        });
    } else {
      this.playInit(channelToPlay, params);
    }
    LayersControl.showPlayer();

    const { user } = this.props;
    let userOTT = user.type && user.type === OTT ? true : false;

    if (document.referrer == '' && !userOTT) {
      if(Utils.isSTBZTE()) {
        let firstTimeZTE = false;
        const enterZteFirstTime =  DeviceStorage.getItem('enterZteFirstTime');
        if(enterZteFirstTime) {
          if(parseInt(enterZteFirstTime) === 1) {
            DeviceStorage.setItem('enterZteFirstTime', 0);
            DeviceStorage.unsetItem('enterZteFirstTime');
            firstTimeZTE = true;
          }
        }
        if(firstTimeZTE) {
          this.history.push(`/node/${this.getLinks().home}`);
        }
      }
      else {
        this.history.push(`/node/${this.getLinks().home}`);
      }
    }
  }

  async showLandingTVEverywhere() {
    let showPage = false;
    const { enable = false, emails_domain_fakes = [] } = Utils.getApaMetadataKey("linkData_notification_config", `{}`);

    if(enable) {
      const { user = {}} = store.getState();
      const validEmail = emails_domain_fakes.some(email => user && user.email && user.email.includes(email));

      if(validEmail) {
        const tvEverywhereCheckTask = new TVEverywhereCheckTask();
        await RequestManager.addRequest(tvEverywhereCheckTask).then((result) => {
          const { data = {}} = result || {};// JSON.parse(result) || {};
          showPage = !(data && data.isChecked);
        }).catch((err) => {
          console.error("Error checking TVEverywhereCheckTask: ", err);
        });
      }
    }
    return this.goToLandingTvEverywhere = showPage;
  }

  redirectTo(initialRoute){
    if (AAF.AdsUtils.isAdsEnable())  {
      const {navbar: {nodes = []}}= store.getState();
      // Obtener el 'code' del node[0]
      let code = nodes && nodes[0] && nodes[0].code ? nodes[0].code : 'homeuser';
      return <Redirect to={(code && (typeof code === 'string') )  && `/node/${code}`} />
    } else {
      console.log('redirectto true initialRoute', initialRoute)

      return <Redirect to={(initialRoute && (typeof initialRoute === 'string') && initialRoute.indexOf('landing')!==-1 )  ? `/${initialRoute}` :`/node/${initialRoute}`} />


    }
  }


  render() {
    console.info('[App] render ', '\nprops', this.props, '\nstate', this.state,'\nthis.stopRender',this.stopRender);
    if(this.props.user.checkShowAlert == true){
      this.checkIfShowAlert(this.props.user);
    }
    if (this.stopRender) {
      return null;
    }

    this.activeMarque =
      this.timeOutAAF && typeof this.timeOutAAF.isActiveMarque === 'function'
        ? this.timeOutAAF.isActiveMarque()
        : false;

    this.getConfigRemoteControl();

    if (this.state.isFetching || !this.state.focusReady) {
      const showLoadingScreen = isLoadingScreenEnabled();

      return showLoadingScreen ? (
        <LoadingScreen />
      ) : (
        <Spinner visible={true} loadingMessage={EpgPersistence.isDatabaseDataSource()} />
      );
    }

    this.checkAppkeyForce();

    if (this.props.user.isLoggedIn && !this.props.user.groups) {
      //se cambian estas llamadas a level
      //this.props.fetchFavoriteVOD(this.props.user, MyContentsettings.myFavorites)
      //this.props.fetchFavoriteChannels(this.props.user, MyContentsettings.myChannels);
    }

    // Para activar debugger, en settings.js poner debugger_enabled a true, abajo actualizar searchstring para buscar la cadena
    const localdebug = settings.debugger_enabled ? (
      <Debugger visible={false} searchstring={'SAMSUNGplayer'}/>
    ) : null;
    const initialRoute = this.getInitialRoute();
    const nodeTV = new ActivesSingleton().getTvNode();
    FallbackHelper.setStartWithTvNode((initialRoute === nodeTV || initialRoute.includes(nodeTV)));


    // Se carga canal TPA si se reinició la caja estando en TPA
    const fireTPAOnReload = DeviceStorage.getItem("fireTPAOnReload");
    if(fireTPAOnReload) {
      DeviceStorage.unsetItem("fireTPAOnReload");
      TvChannelUtil.setLastChannel(fireTPAOnReload);
    }

    return (
      <div>
        {this.device === 'nagra' ? (
          <div id="nagraKeyLinks">
            <a id="musicLink" href="/node/claromusica"/>
          </div>
        ) : null}
        <Marquee active={this.activeMarque} />
        <Focus />
        {/*<KeyLogger/>*/}
        <Spinner className='app-profile-none'/>
        <Router history={this.history}>
          <div>
            {localdebug}
            <div id="uxMain">
              <div id="blur" className="" />
              <Route
                exact
                path="/"
                render={() => (
                  this.redirectTo(initialRoute)

                  // Para debug fox v3<Redirect to={`/vcard/759580`} />
                )}
              />

              <Route
                exact
                path="/migracion/landing"
                render={({history}) => <LandingPageSTB history={history}/>}
              />
              <Route
                exact
                path="/landing-tv-everywhere"
                render={({history}) => <LandingTVEverywhere history={history} ifPromptTVNode={this.ifPromptTVNode.bind(this)}/>}
              />



              <Route
                render={({ location, history }) => {
                  const path = location.pathname.split('/node/');
                  let currentNode = path.length >= 2 ? path[1] : null;
                  if(currentNode === null && (path && path[0] && path[0] === '/search')){
                    currentNode = 'search';
                  }

                  const isNodeTV = this.isNodeTV(location);

                  const showHeader =
                    !location.pathname.includes('/player/') &&
                    !location.pathname.includes('/endplayer/') &&
                    !isNodeTV;
                  const isIpTelmex = location.pathname.includes('iptelmex');
                  const isProfile = location.pathname.includes('/profile');
                  const isLandingMigrationZTE = location.pathname.includes('migracion/landing');
                  const isLanding = (location.pathname.includes('/landing') && !location.pathname.includes('migracion/landing')) || (location.pathname === '/' && initialRoute === 'landing');
                  const isPaymentMethod = location.pathname.includes('/payment-method');
                  const isPaymentTelcel = location.pathname.includes('/payment-hubgate');
                  const isPaymentCard = location.pathname.includes('/payment-claropagosgate');
                  const isPaymentCode = location.pathname.includes('/payment-promogate');
                  const isFacturaFija = location.pathname.includes('/payment-hubfacturafijagate');
                  const isHubFijoGate = location.pathname.includes('/payment-hubfijogate');
                  const isHubBidirectionalGate = location.pathname.includes('/payment-hubbidirectional');
                  const isDetailSelector = location.pathname.includes('/detailSelector');
                  const isclarocolombiagate = location.pathname.includes('/payment-clarocolombiagate');
                  const isLoginN = location.pathname.includes('/login') ;
                  const isRegisterN = location.pathname.includes('/register');
                  const isPasswordReminderN = location.pathname.includes('/password-reminder');
                  const isPtvNew = location.pathname.includes('/ptv');
                  const isAuthdevice = location.pathname.includes('/authdevice');
                  const isConfig = /^\/config\/[^/]+$/.test(location.pathname);
                    currentNode = location.pathname.includes('/vcard/')
                      ? 'vcard'
                      : currentNode;
                  const isPlanSelector = location.pathname.includes(`/${settings.path_suscription}`) || location.pathname.includes('detailtransaction');
                  const isLandingTVEverywhere = location.pathname.includes(`/landing-tv-everywhere`);

                  return showHeader &&
                    !isIpTelmex &&
                    !isProfile &&
                    !isLanding &&
                    !isLandingMigrationZTE &&
                    !isPaymentMethod &&
                    !isPaymentTelcel &&
                    !isPaymentCard &&
                    !isPaymentCode &&
                    !isFacturaFija &&
                    !isHubFijoGate &&
                    !isHubBidirectionalGate &&
                    !isLoginN &&
                    !isRegisterN &&
                    !isPasswordReminderN &&
                    !isDetailSelector &&
                    !isPlanSelector &&
                    !isclarocolombiagate &&
                    !isPtvNew &&
                    !isLandingTVEverywhere &&
                    !isAuthdevice &&
                    !isConfig ? (
                      <Header
                        user={this.props.user}
                        profile={this.props.profile}
                        nodes={this.state.nodes}
                        refresh={this.state.refresh}
                        initialRoute={currentNode ? currentNode : "default"}
                        changePath={this.changePath}
                        history={history}
                        setResumeDataEmpty={this.setResumeDataEmpty}
                        showAlert={this.showAlert}
                      />
                    ) : null;
                }}
              />


              <Route
                path="/endplayer/:groupId"
                render={({ location }) => {
                  const { state } = location;
                  return (
                    <EndPlayer
                      groupId={state.groupId}
                      title={state.title}
                      previewImg={state.previewImg}
                      backgroundImg={state.backgroundImg}
                      next={state.next}
                      recommendations={state.recommendations}
                      serieData={state.serieData}
                    />
                  );
                }}
              />

              <div id="container" className="container">
                <Route
                  render={({ location }) => {
                    const isNodeTV = this.isNodeTV(location);
                    let showResume = false &&
                      (location.pathname.includes('/node') &&
                        !isNodeTV) /*&&
                       !location.pathname.includes('claromusica') ||*/
                      // location.pathname.includes('/vcard');

                    const noBanner =
                      location.pathname.includes('/epg') && !showResume;
                    if (noBanner) return <Resume hide={true} />;
                    else if (showResume && !noBanner)
                      return (
                        <Resume
                          setMetricsEvent={this.props.setMetricsEvent}
                          closeModal={this.closeModal}
                          history={this.history}
                        />
                      );
                    else return null;
                  }}
                />
                <Prompt
                  message={(location, action) => {
                    //return true
                    let nodeTV = new ActivesSingleton().getTvNode();
                    let isTVNode = false;
                    //nodeTV = 'guia';

                    console.log('********* location', location);

                    if (location.pathname.includes('/node/')) {
                      let code = location.pathname.split('/')[2];
                      console.log('**** El nodo es *****', code);

                      /* Mandar "/services/user/v1/statuscontrolpin" en nodo mis contenidos.
                      Setea en redux los nuevos group_id de los canales bloqueados (pin_channel). */
                      if (code === "miscontenidos") {
                        this.checkStatusPin();
                      }

                      //Pone el foco temporalmente en el nodo activo del menu, para hacer el desplazamiento de scroll que corresponda
                      Utils.setInitialFocus('#aaf_menu-container-center .active.focusable');
                      //Inizializa el valor del margin top cada que se cambia de nodo
                      Utils.setMaxRibbonMarginTop(0);

                      let currentNode = [];

                      let findNode = (node, index) => {
                        if (node.code === code) {
                          currentNode = node;
                        } else if (node.childs && node.childs.forEach) {
                          node.childs.forEach(findNode);
                        }
                      };

                      this.state.nodes.forEach(findNode);

                      if (
                        currentNode &&
                        currentNode.app_behaviour &&
                        currentNode.app_behaviour !== null
                      ) {
                        let app_behaviour = JSON.parse(
                          currentNode.app_behaviour
                        );

                        if (
                          app_behaviour &&
                          app_behaviour.layout === 'guidechannels'
                        ) {
                          isTVNode = true;
                        }
                      }
                    }

                    console.log('****** isTVNode', isTVNode);

                    const { publicity, rolls } = store.getState().ads;

                    isTVNode && store.dispatch(setContentDataPublicity({
                      publicity,
                      rolls,
                      currentContentType: "",
                    }));

                    //if(location.pathname==('/node/'+nodeTV))
                    if (isTVNode || location.pathname == '/node/' + nodeTV || location.pathname.includes(isTVNode)) {
                      // Verificar si ya cargué lo que deba cargar de los canales
                      NewRelic.addPageAction('enter-tv-mode', {node:location.pathname});

                      // Validación para llamar a la recordings/vX/list cuando se entra al nodo de TV en vivo
                      const user = store.getState().user;
                      const isAdsEnable = AAF.AdsUtils.isAdsEnable();
                      const userType = AAF.AdsUtils.getUserType();
                      const isUserFreemiumOrAnonymous = isAdsEnable ? AAF.AdsUtils.isUserFreemium(userType) : user.isAnonymous;
                      if (!isUserFreemiumOrAnonymous && NpvrUtil.recordingIconEnable().enable) {
                        new EpgFeederManager().boot();
                      }

                      const lastUrl = this.history && this.history.location && this.history.location.pathname;
                      if(lastUrl === "/search"){
                        ClearTextSearch.fire();
                      }

                      if(!LoadingIptvOttFlow.isLoadLive()){
                        this.loadLinealChannels();
                        LiveObserver.fire();
                      };

                      if(this.goToLandingTvEverywhere) {
                        this.history.push(`/landing-tv-everywhere`);
                      } else {
                          this.ifPromptTVNode(location);
                      }
                      this.goToLandingTvEverywhere = false;
                    }
                    return !(location.pathname == '/node/' + nodeTV || location.pathname.includes(nodeTV));
                  }}
                />

                <Route
                  path="/payment/:groupId/:offerId"
                  render={props => <Payment refresh={this.refresh} />}
                />

                <Route path="/planSelector" component={PlanSelectorNew} />
                <Route path="/detailtransaction"  component={(props) => <TransactionDetailContainer {...props} nodes={this.state.nodes}/> }/>

                <Route path="/my-content" component={MyContent} />
                <Route
                  path="/search"
                  render={() => (
                      <ChooseSearcher
                        setMetricsEvent={this.setMetricsEvent}
                        user={this.props.user}
                        history={this.history}
                        chargeLiveComponents={this.chargeLiveComponents}
                        loadLinealChannels={this.loadLinealChannels}
                      />
                    )}
                />
                <Route
                  path="/socialProfile/:gamificationId"
                  render={props => (
                    <SocialContainer getLinks={this.getLinks} {...props}/>
                  )}
                />
                <Route
                  path="/node/:code"
                  render={props => (
                    <NodeContent
                      user={this.props.user}
                      updateFavoriteVOD={this.updateFavoriteVOD}
                      updateFavoriteChannels={this.updateFavoriteChannels}
                      initialRoute = {initialRoute}
                      {...props}
                      nodes={this.state.nodes}
                      loadLinealChannels={this.loadLinealChannels}
                    />
                  )}
                />
                <Route
                  path="/vcard/:groupId/:ignoreSeenLast?"
                  component={NewNewVCard}
                />
                <Route path="/epg/:groupId" component={VCardTv} />
                <Route
                  path="/talent/:id/:fullname/:provider_id"
                  component={() => <Talent user={this.props.user} />}
                />
                <Route
                  path="/user-settings/:section?/:subsection?"
                  component={UserSettings}
                />
                <Route path="/about" component={About} />
                <Route
                    path="/login"
                    component={props => <Login {...props} />}
                />
                <Route
                    path="/loginCM"
                    component={props => <LoginCM {...props} />}
                />
                <Route
                    path="/password-reminder"
                    component={props => <PasswordReminder {...props} />}
                />
                <Route
                    path="/authdevice"
                    component={props => <AuthDevice user={this.props.user} {...props} />}
                />
                <Route
                    path="/register"
                    component={props => <Register {...props} />}
                />
                <Route path="/radioList/genre/:name" component={GenreRadioList} />
                <Route path="/radioList/artist/:id" component={ArtistRadioList} />
                <Route path="/artist/:artistId" component={Artist} />
                <Route path="/playlist/:groupId" component={Playlist} />
                <Route path="/album/:groupId" component={Album} />
                <Route path="/landing" exact render={(props) => <LandingResolver {...props} linksNav = {this.getLinks()}/>}/>
                <Route path="/detailSelector" component={DetailSelector}/>
                <Route
                  path="/special/:name"
                  render={props => (
                    <SpecialContainer user={this.props.user} {...props} />
                  )}
                />
                <Route path="/iptelmex/" component={LoadRegisterIpTelmex}
                />
                <Route path="/ptv" component={props => <PTV {...props}/>}/>
                <Route path="/profile/:name?" render={(props) => <Profile {...props} finishLanding={this.callbackAfterLoginInProfile}/>} />
                <Route
                  path='/payment-method' render={props => <PaymentMethods {...props}/>}
                />
                <Route path='/payment-hubgate' component={props => <PaymentHubGate {...props} nodes={this.state.nodes} />}/>
                <Route path='/payment-claropagosgate' component={props => <PaymentCard {...props} nodes={this.state.nodes} />}/>
                <Route path='/payment-promogate' component={props => <PaymentPromoGate {...props} nodes={this.state.nodes} />}/>
                <Route path='/payment-hubfacturafijagate' component={props => <HubFacturaFijaGate {...props} nodes={this.state.nodes} />} />
                <Route path='/payment-hubfijogate' component={props =>  <HubFija {...props} nodes={this.state.nodes} />} />
                <Route path='/payment-clarocolombiagate' component={props =>  <PaymentGate {...props} nodes={this.state.nodes} />} />
                <Route path='/payment-hubbidirectional' component={props =>  <HubBidirectional {...props} nodes={this.state.nodes} />} />
                <Route path='/payment-hubbidirectionalCO' component={props =>  <HubBidirectionalCO {...props} nodes={this.state.nodes} />} />
                <Route exact path='/config/' component={props =>  <Config />} />
                <Route path='/config/:type' component={ConfigDetails} />
              </div>
              <VolumeIndicator ref="VolInd" />
              {/* { localdebug } */}
            </div>
            <Notification />
            <ModalConductor history={this.history} getLinks={this.getLinks}/>
          </div>
        </Router>
        <FullVideo
          classVideo="full"
          id="playerMain"
          setMetricsEvent={this.setMetricsEvent}
          user={this.props.user}
          changePath={this.changePath}
          setAafLiveHistory={this.setAafLiveHistory}
          updateApp={this.updateApp}
          clearTimeOutAAF={this.clearTimeOutAAF}
          startTimeOutAAF={this.startTimeOutAAF}
          history={this.history}
        />
        {false && <PipVideo classVideo="pip" />}
        <WaterMark />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { linealChannels: state.linealChannels, user: state.user, profile: state.profile, nodes: state.nodes };
};
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchIsLoggedIn,
      fetchFavoriteVOD,
      fetchFavoriteChannels,
      fetchSmartCardLogin,
      fetchLinealChannels,
      fetchAuthDevice,
      showModal,
      showNotification,
      playFullMedia,
      playPipMedia,
      replaceFullSourceMedia,
      setMetricsEvent,
      setResumeData,
      fetchPushSession,
      showEventReminderNotification,
      setLastTouchReminder,
      hideNotification,
      setNodes,
      fetchAuthDeviceCMR,
      fetchLoginByToken,
      continueProcessLoginByToken
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.jsx